// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".course-settings .course-assets-modal{display:flex;flex-direction:column;background-color:#fff;padding:24px}.course-settings .course-assets-modal .footer,.course-settings .course-assets-modal .header{display:flex;width:100%;justify-content:center}.course-settings .course-assets-modal .footer{justify-content:flex-end}.course-settings .course-assets-modal .footer .btn{width:150px}.course-settings .course-assets-modal .footer .btn i{color:inherit}", ""]);
// Exports
module.exports = exports;
